import { createFileRoute } from '@tanstack/react-router';
import { AudiencesPage } from '@web/modules/campaigns/audiences/audiences-page';

export const Route = createFileRoute('/_app/campaigns/audiences/')({
  component: AudiencesPage,
});
